@if (devicePopup === 'deviceSelected') {
  <div class="modal-body device-selection">
    <div class="row">
      <div class="col-6">
        <p class="device-modal-title">Selected Device</p>
      </div>
      <div class="offset-4 col-2 close-btn">
        <button type="button" class="firefox-changes-border" aria-label="Close"
          (click)="[activeModal.dismiss('Cross click'), remove()]">
          <img class="" src="/assets/img/close.png" alt="Close">
        </button>
      </div>
    </div>
  </div>
}

@if (devicePopup === 'deviceSelected') {
  <div>
    <div class="device-selected-container">
      <!-- Device Header Section -->
      <div class="device-header-section">
        <table class="device-info-table">
          <caption class="dn">Device Information</caption>
          <thead class="dn">
            <tr>
              <th scope="col">Field</th>
              <th scope="col">Value</th>
              <th scope="col">Image</th>
            </tr>
          </thead>
          <tr>
            <td class="device-info-label">Product Name:</td>
            <td class="device-info-value">{{device.deviceName}}</td>
            <td class="device-image-cell" rowspan="2">
              @if (device.devicetypePicture!=null) {
                <img class="device-img" src="{{device.devicetypePicture}}" alt="">
              }
            </td>
          </tr>
          <tr>
            <td class="device-info-label">12 NC:</td>
            <td class="device-info-value">{{device.device12nc}}</td>
          </tr>
        </table>
      </div>
      <!-- Device Details Table -->
      <div class="table-responsive device-details-table-wrapper">
        <table class="table table-bordered device-details-table">
          <caption class="dn">Device Details</caption>
          <thead class="dn">
            <tr>
              <th scope="col">Feature</th>
              <th scope="col">Value</th>
              <th scope="col">Feature</th>
              <th scope="col">Value</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="feature-label-left">
                <span class="add-info">Pout</span>
                <p class="sub-val">max (W)</p>
              </td>
              <td class="feature-value-left">
                @if (device.opMax) {
                  <span class="custom-info-val">{{device.opMax}}</span>
                }
                @if (device.opMax === '') {
                  <span class="empty-Value">-</span>
                }
              </td>
              <td class="feature-label-right">Firmware no.</td>
              <td class="feature-value-right">
                @if (softwareVersions[device.device12nc] && softwareVersions[device.device12nc].versions.length == 1) {
                  <div>
                    @for (ver of softwareVersions[device.device12nc].versions; track ver) {
                      <span class="info-val">{{ ver.version }}</span>
                    }
                  </div>
                }
                @if (softwareVersions[device.device12nc] && softwareVersions[device.device12nc].versions.length > 1) {
                  <div>
                    <select class="select-modal select-padding" (change)="selectVersion($event.target.value, device.device12nc)">
                      @for (version of softwareVersions[device.device12nc].versions; track version) {
                        <option [selected]="version.selected"
                          [value]="version.version" class="info-val">
                          {{version.version}}
                        </option>
                      }
                    </select>
                  </div>
                }
              </td>
            </tr>
            <tr>
              <td class="feature-label-left">
                <span class="add-info">I out</span>
                <p class="sub-val">min (mA)</p>
              </td>
              <td class="feature-value-left">
                @if (device.ioutMin) {
                  <span class="custom-info-val">{{device.ioutMin}}</span>
                }
                @if (device.ioutMin === '') {
                  <span class="empty-Value">-</span>
                }
              </td>
              <td class="feature-label-right">V out <p class="sub-val">max (V)</p></td>
              <td class="feature-value-right">
                @if (device.voutMax) {
                  <span class="info-val">{{device.voutMax}}</span>
                }
                @if (device.voutMax === '') {
                  <span>-</span>
                }
              </td>
            </tr>
            <tr>
              <td class="feature-label-left">
                <span class="add-info">I out</span>
                <p class="sub-val">max (mA)</p>
              </td>
              <td class="feature-value-left">
                @if (device.ioutMax) {
                  <span class="custom-info-val">{{device.ioutMax}}</span>
                }
                @if (device.ioutMax === '') {
                  <span class="empty-Value">-</span>
                }
              </td>
              <td class="feature-label-right">Dimming</td>
              <td class="feature-value-right">
                @for (dim of device.dimmingFeatures; track dim; let isLast = $last) {
                  <span class="info-val">
                    {{dim.name}}{{isLast ? '' : ', '}}
                  </span>
                }
              </td>
            </tr>
            <tr>
              <td class="feature-label-left">
                <span class="add-info">V out</span>
                <p class="sub-val">min (V)</p>
              </td>
              <td class="feature-value-left">
                @if (device.voutMin) {
                  <span class="custom-info-val">{{device.voutMin}}</span>
                }
                @if (device.voutMin === '') {
                  <span class="empty-Value">-</span>
                }
              </td>
              <td class="feature-label-right">Datasheet</td>
              <td class="feature-value-right">
                @if (device.datasheetLink!=null) {
                  <span class="info-val">
                    <a class="view-datasheet" target="_blank" href="{{device.datasheetLink}}">View</a>
                  </span>
                }
              </td>
            </tr>
            <tr>
              <td class="feature-label-left">
                Length
                <p class="sub-val">(mm)</p>
              </td>
              <td class="feature-value-left">
                @if (device.length) {
                  <span class="info-val">{{device.length}}</span>
                }
                @if (device.length === '') {
                  <span>-</span>
                }
              </td>
              <td class="feature-label-right">Application</td>
              <td class="feature-value-right">
                <span class="info-val">{{device.applicationArea}}</span>
              </td>
            </tr>
            <tr>
              <td class="feature-label-left">
                Width
                <p class="sub-val">(mm)</p>
              </td>
              <td class="feature-value-left">
                @if (device.width) {
                  <span class="info-val">{{device.width}}</span>
                }
                @if (device.width === '') {
                  <span>-</span>
                }
              </td>
              <td class="feature-label-right">Mounting</td>
              <td class="feature-value-right">
                @for (mount of device.mounting; track mount; let isLast = $last) {
                  <span class="info-val">
                    {{mount.name}}{{isLast ? '' : ', '}}
                  </span>
                }
              </td>
            </tr>
            <tr>
              <td class="feature-label-left">
                Height
                <p class="sub-val">(mm)</p>
              </td>
              <td class="feature-value-left">
                @if (device.height) {
                  <span class="info-val">{{device.height}}</span>
                }
                @if (device.height === '') {
                  <span>-</span>
                }
              </td>
              <td class="feature-label-right">Configuration Interface</td>
              <td class="feature-value-right">
                @for (config of device.configurationInterface; track config; let isLast = $last) {
                  <span class="info-val">
                    {{config}}{{isLast ? '' : ', '}}
                  </span>
                }
              </td>
            </tr>
            <tr>
              <td class="feature-label-left">
                <span class="add-info">Efficiency</span>
                <span class="add-info-top">at full Load</span>
                <p class="sub-val">(%)</p>
              </td>
              <td class="feature-value-left" colspan="3">
                @if (device.efficiencyFullLoad) {
                  <span class="info-val">{{device.efficiencyFullLoad | number:'1.2-2'}}</span>
                }
                @if (device.efficiencyFullLoad === '') {
                  <span class="empty-Value">-</span>
                }
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      @if (loading) {
        <div class="spinner-border custom-spinner-compare"></div>
      }
      <!-- Button Section -->
      <div class="row btn-container">
        <div class="col-4"></div>
        <div class="offset-4 col-4 select-button">
          <button
            type="button"
            class="btn select-btn"
            [class.disabled-btn]="isSelectDisabled"
            [disabled]="isSelectDisabled"
            (click)="configDevice()"
            >
            Select
          </button>
        </div>
      </div>
    </div>
  </div>
}





<!-- Start for compare device popup-->

@if (devicePopup === 'compareDevices') {
  <div class="modal-body compare-devices-container"
    [ngClass]="{'modal-size':selectedComparingDevices.length >2}">
    <div class="row list">
      <button type="button" class="col-12 close-btn-img firefox-changes-border"
        (click)="activeModal.close('Close click')">
        <img class="" src="/assets/img/close.png" alt="Close">
      </button>
    </div>
    <p class="device-modal-title-compare" style="margin-top: 10px; margin-bottom: 5px;">Compare Devices</p>
    @if (loading) {
      <div class="spinner-border custom-spinner-compare"></div>
    }
    <div class="table-responsive">
      <table class="table table-bordered compare-devices-table">
        <thead>
          <tr>
            <th class="features-column">Features</th>
            @for (compareDevice of selectedComparingDevices; track compareDevice; let i = $index) {
              <th
                [ngClass]="[selectedComparingDevices.length <=2 ? 'device-column-wide' : 'device-column']">
                <div class="device-header">
                  <p class="device-modal-sub-title-compare" style="margin-top: 8px; margin-bottom: 5px;"
                 [ngClass]="{'margin-top-device-name': compareDevice.deviceName.length <= 36 && selectedComparingDevices.length <=2,
                            'device-names-less-chars': compareDevice.deviceName.length <= 20}">
                {{compareDevice.deviceName}}
              </p>
              <div class="device-img-placeholder">
                @if (compareDevice.devicetypePicture!=null) {
<img class="device-img" src="{{compareDevice.devicetypePicture}}"
                  alt="">
                    }
                  </div>
                  <div class="device-modal-sub-title-compare" style="margin-top: 5px; margin-bottom: 5px;">{{compareDevice.device12nc}}</div>
                </div>
              </th>
            }
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="feature-label firmware-padding">Firmware no.</td>
            @for (compareDevice of selectedComparingDevices; track compareDevice) {
              <td class="device-value">
                <div class="select-margin-compare">
                  @if (softwareVersions[compareDevice.device12nc] && softwareVersions[compareDevice.device12nc].versions.length == 1) {
                    <div
                      class="firmware-span-compare-div">
                      @for (version of softwareVersions[compareDevice.device12nc].versions; track version) {
                        <span class="info-val firmware-span-compare">
                          {{ version.version }}
                        </span>
                      }
                    </div>
                  }
                  @if (softwareVersions[compareDevice.device12nc] && softwareVersions[compareDevice.device12nc].versions.length > 1) {
                    <div>
                      @if (fwversion.device12nc === compareDevice.device12nc) {
                        <select class="select-modal firmware" (change)="selectVersion($event.target.value, compareDevice.device12nc)"
                          >
                          @for (version of softwareVersions[compareDevice.device12nc].versions; track version) {
                            <option [value]="version.version" [selected]="version.selected" class="info-val">
                              {{ version.version }}
                            </option>
                          }
                        </select>
                      }
                    </div>
                  }
                </div>
              </td>
            }
          </tr>
          <tr>
            <td class="feature-label margin-top-dim">Dimming</td>
            @for (compareDevice of selectedComparingDevices; track compareDevice) {
              <td class="device-value">
                @for (dim of compareDevice.dimmingFeatures; track dim; let isLast = $last) {
                  <span>
                    {{dim.name}}{{isLast ? '' : ', '}}
                  </span>
                }
              </td>
            }
          </tr>
          <tr>
            <td class="feature-label">Datasheet</td>
            @for (compareDevice of selectedComparingDevices; track compareDevice) {
              <td class="device-value">
                @if (compareDevice.datasheetLink!=null) {
                  <span class="info-val">
                    <a class="view-datasheet" target="_blank" href="{{compareDevice.datasheetLink}}">View</a>
                  </span>
                }
              </td>
            }
          </tr>
          <tr>
            <td class="feature-label">Application</td>
            @for (compareDevice of selectedComparingDevices; track compareDevice) {
              <td class="device-value">
                {{compareDevice.applicationArea}}
              </td>
            }
          </tr>
          <tr>
            <td class="feature-label">Mounting</td>
            @for (compareDevice of selectedComparingDevices; track compareDevice) {
              <td class="device-value">
                @for (mount of compareDevice.mounting; track mount; let isLast = $last) {
                  <span>
                    {{mount.name}}{{isLast ? '' : ', '}}
                  </span>
                }
              </td>
            }
          </tr>
          <tr>
            <td class="feature-label">Set output current</td>
            @for (compareDevice of selectedComparingDevices; track compareDevice) {
              <td class="device-value">
                {{compareDevice?.isolation?.name}}
              </td>
            }
          </tr>
          <tr>
            <td class="feature-label">
              <span class="add-info">Pout</span>
              <p class="sub-val">max (W)</p>
            </td>
            @for (compareDevice of selectedComparingDevices; track compareDevice) {
              <td class="device-value">
                {{compareDevice.opMax!=0?compareDevice.opMax:null}}
              </td>
            }
          </tr>
          <tr>
            <td class="feature-label">
              I out
              <p class="sub-val">min (mA)</p>
            </td>
            @for (compareDevice of selectedComparingDevices; track compareDevice) {
              <td class="device-value">
                {{compareDevice.ioutMin!=0?compareDevice.ioutMin:null}}
              </td>
            }
          </tr>
          <tr>
            <td class="feature-label">
              I out
              <p class="sub-val">max (mA)</p>
            </td>
            @for (compareDevice of selectedComparingDevices; track compareDevice) {
              <td class="device-value">
                {{compareDevice.ioutMax!=0?compareDevice.ioutMax:null}}
              </td>
            }
          </tr>
          <tr>
            <td class="feature-label">
              V out
              <p class="sub-val">min (v)</p>
            </td>
            @for (compareDevice of selectedComparingDevices; track compareDevice) {
              <td class="device-value">
                {{compareDevice.voutMin!=0?compareDevice.voutMin:null}}
              </td>
            }
          </tr>
          <tr>
            <td class="feature-label">
              V out
              <p class="sub-val">max (v)</p>
            </td>
            @for (compareDevice of selectedComparingDevices; track compareDevice) {
              <td class="device-value">
                {{compareDevice.voutMax!=0?compareDevice.voutMax:null}}
              </td>
            }
          </tr>
          <tr>
            <td class="feature-label">
              Length
              <p class="sub-val">(mm)</p>
            </td>
            @for (compareDevice of selectedComparingDevices; track compareDevice) {
              <td class="device-value">
                {{compareDevice.length!=0?compareDevice.length:null}}
              </td>
            }
          </tr>
          <tr>
            <td class="feature-label">
              Width
              <p class="sub-val">(mm)</p>
            </td>
            @for (compareDevice of selectedComparingDevices; track compareDevice) {
              <td class="device-value">
                {{compareDevice.width!=0?compareDevice.width:null}}
              </td>
            }
          </tr>
          <tr>
            <td class="feature-label">
              Height
              <p class="sub-val">(mm)</p>
            </td>
            @for (compareDevice of selectedComparingDevices; track compareDevice) {
              <td class="device-value">
                {{compareDevice.height!=0?compareDevice.height:null}}
              </td>
            }
          </tr>
          <tr>
            <td class="feature-label">
              Efficiency at full load
              <p class="sub-val">(%)</p>
            </td>
            @for (compareDevice of selectedComparingDevices; track compareDevice) {
              <td class="device-value">
                {{compareDevice.efficiencyFullLoad!=0?compareDevice.efficiencyFullLoad:null}}
              </td>
            }
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Select buttons container outside table -->
    <div class="select-buttons-container">
      <div class="features-column-spacer"></div>
      @for (compareDevice of selectedComparingDevices; track compareDevice; let i = $index) {
        <div class="select-button-wrapper"
          [ngClass]="[selectedComparingDevices.length <=2 ? 'button-wrapper-wide' : 'button-wrapper']">
          <button class="btn select-button-compare" [disabled]="isSelectDisabled" (click)="[selectingDevice(compareDevice,i)]">Select</button>
        </div>
      }
    </div>
  </div>
}
<!-- End for compare device popup-->
<!-- Start for Column selection popup-->
@if (devicePopup === 'columnSelected') {
  <div class="modal-body-column">
    <div class="close-icon">
      <button type="button" class="firefox-changes-border" aria-label="Close"
        (click)="activeModal.dismiss('Cross click')">
        <img class="" src="/assets/img/close.png" alt="Close">
      </button>
    </div>
    <div class="row column-container-visible">
      <div>Visible columns ( {{countColumns}} of 18 )</div>
    </div>
    <div class="row column-container-all">
      <div class="col-12 custom-checked">
        <input [checked]="hideSelectAll" type="checkbox" class="primary-checkbox" id="selectAll"
          (change)="selectAll($event.target.checked)" />
          <label for="selectAll" aria-label="Select All Columns"><span></span></label>All Column
        </div>
      </div>
      <div class="row column-container select-margin">
        <form [formGroup]="columnSelection" (ngSubmit)="onSubmit()">
          <div class="col-12 custom-checked">
            <input [checked]="true" type="checkbox" class="primary-checkbox disabled-checkbox" id="hide12nc" disabled />
              <label for="hide12nc" aria-label="12 NC"><span></span></label><span class="column-available">12 nc</span>
            </div>
            <div class="col-12 custom-checked">
              <input [checked]="hideDeviceName" type="checkbox" class="primary-checkbox" id="deviceName"
                (change)="selectColumn('deviceName',$event.target.checked)" />
                <label for="deviceName" aria-label="Product Name"><span></span></label><span class="column-available">Product Name</span>
              </div>
              <div class="col-12 custom-checked">
                <input [checked]="hideDatasheetLink" type="checkbox" class="primary-checkbox" id="datasheet"
                  (change)="selectColumn('datasheet',$event.target.checked)" />
                  <label for="datasheet" aria-label="Datasheet Link"><span></span></label><span class="column-available">Datasheet Link</span>
                </div>
                <div class="col-12 custom-checked">
                  <input [checked]="hideApplication" type="checkbox" class="primary-checkbox" id="applicationArea"
                    (change)="selectColumn('applicationArea',$event.target.checked)" />
                    <label for="applicationArea" aria-label="Application Area"><span></span></label><span class="column-available">Application Area</span>
                  </div>
                  <div class="col-12 custom-checked">
                    <input [checked]="hidePout" type="checkbox" class="primary-checkbox" id="pout"
                      (change)="selectColumn('pOut',$event.target.checked)" />
                      <label for="pout" aria-label="Pout"><span></span></label><span class="column-available">Pout</span>
                    </div>
                    <div class="col-12 custom-checked">
                      <input [checked]="hideIoutMin" type="checkbox" class="primary-checkbox" id="ioutmin"
                        (change)="selectColumn('iOutMin',$event.target.checked)" />
                        <label for="ioutmin" aria-label="Iout Min"><span></span></label><span class="column-available">Iout Min</span>
                      </div>
                      <div class="col-12 custom-checked">
                        <input [checked]="hideIoutMax" type="checkbox" class="primary-checkbox" id="ioutmax"
                          (change)="selectColumn('iOutMax',$event.target.checked)" />
                          <label for="ioutmax" aria-label="Iout Max"><span></span></label><span class="column-available">Iout Max</span>
                        </div>
                        <div class="col-12 custom-checked">
                          <input [checked]="hideVoutMax" type="checkbox" class="primary-checkbox" id="voutmax"
                            (change)="selectColumn('vOutMax',$event.target.checked)" />
                            <label for="voutmax" aria-label="Vout Max"><span></span></label><span class="column-available">Vout Max</span>
                          </div>
                          <div class="col-12 custom-checked">
                            <input [checked]="hideVoutMin" type="checkbox" class="primary-checkbox" id="voutmin"
                              (change)="selectColumn('vOutMin',$event.target.checked)" />
                              <label for="voutmin" aria-label="Vout Min"><span></span></label><span class="column-available">Vout Min</span>
                            </div>
                            <div class="col-12 custom-checked">
                              <input [checked]="hideInterface" type="checkbox" class="primary-checkbox" id="configInterface"
                                (change)="selectColumn('configInterface',$event.target.checked)" />
                                <label for="configInterface" aria-label="Configuration Interface"><span></span></label><span class="column-available">Configuration Interface</span>
                              </div>
                              <div class="col-12 custom-checked">
                                <input [checked]="hideDimming" type="checkbox" class="primary-checkbox" id="dimming"
                                  (change)="selectColumn('dimming',$event.target.checked)" />
                                  <label for="dimming" aria-label="Dimming Features"><span></span></label><span class="column-available">Dimming Features</span>
                                </div>
                                <div class="col-12 custom-checked">
                                  <input [checked]="hideEfficiency" type="checkbox" class="primary-checkbox" id="efficiency"
                                    (change)="selectColumn('efficiency',$event.target.checked)" />
                                    <label for="efficiency" aria-label="Efficiency Full Load"><span></span></label><span class="column-available">Efficiency Full Load</span>
                                  </div>
                                  <div class="col-12 custom-checked">
                                    <input [checked]="hideIsolation" type="checkbox" class="primary-checkbox" id="isolation"
                                      (change)="selectColumn('isolation',$event.target.checked)" />
                                      <label for="isolation" aria-label="Isolation"><span></span></label><span class="column-available">Isolation</span>
                                    </div>
                                    <div class="col-12 custom-checked">
                                      <input [checked]="hideMounting" type="checkbox" class="primary-checkbox" id="moutning"
                                        (change)="selectColumn('moutning',$event.target.checked)" />
                                        <label for="moutning" aria-label="Mounting"><span></span></label><span class="column-available">Mounting</span>
                                      </div>
                                      <div class="col-12 custom-checked">
                                        <input [checked]="hideLength" type="checkbox" class="primary-checkbox" id="length"
                                          (change)="selectColumn('length',$event.target.checked)" />
                                          <label for="length" aria-label="Length"><span></span></label><span class="column-available">Length</span>
                                        </div>
                                        <div class="col-12 custom-checked">
                                          <input [checked]="hideWidth" type="checkbox" class="primary-checkbox" id="width"
                                            (change)="selectColumn('width',$event.target.checked)" />
                                            <label for="width" aria-label="Width"><span></span></label><span class="column-available">Width</span>
                                          </div>
                                          <div class="col-12 custom-checked">
                                            <input [checked]="hideHeight" type="checkbox" class="primary-checkbox" id="height"
                                              (change)="selectColumn('height',$event.target.checked)" />
                                              <label for="height" aria-label="Height"><span></span></label><span class="column-available">Height</span>
                                            </div>
                                            <div class="col-12 custom-checked">
                                              <input [checked]="hideSimpleSetMultiDeviceConfiguration" type="checkbox" class="primary-checkbox"
                                                id="SimpleSetBoxConfiguration"
                                                (change)="selectColumn('SimpleSetBoxConfiguration',$event.target.checked)" />
                                                <label for="SimpleSetBoxConfiguration" aria-label="Box Configuration"><span></span></label><span class="column-available">Box
                                              configuration</span>
                                            </div>
                                            @if (isDisbaleBtn) {
                                              <div class="text-danger">Please select at least 1 Column</div>
                                            }
                                            <div class="row column-container">
                                              <div class="col-7">
                                                <button [disabled]="isDisbaleBtn" type="submit" class="btn confirm-btn"
                                                [ngClass]="{'disableConfirm':isDisbaleBtn}">Confirm</button>
                                              </div>
                                            </div>
                                          </form>
                                        </div>
                                      </div>
                                    }
                                    <!-- End for Column selection popup-->

                                    <!-- uploading start here-->

                                    @if (devicePopup === 'uploadDCF') {
                                      <div class="modal-body new-device-selection">
                                        @if (isErrorPopup) {
                                          <div class="row compare-devices">
                                            <div class="col-7 signifyBoldxl no-padding">Partially compatible features</div>
                                            <div class="col-5 signifyBookmd">(compatible features:
                                              @for (upload of uploadFeature.successfulFeatures; track upload; let lastItem = $last) {
                                                <span>{{upload}}
                                                  @if (!lastItem) {
                                                    <span>,&nbsp;</span>
                                                  }
                                                </span>
                                                })
                                              </div><br><br><br>
                                              <div class="col-12 signifyBookmd no-padding">Selected device:</div><br>
                                              <div class="col-12 signifyBooklg no-padding add-margin">{{device.deviceName}}</div>
                                              <div class="col-12 signifyBookmd no-padding">Original device:</div><br>
                                              <div class="col-12 signifyBooklg no-padding">{{decryptData?.deviceName}}</div>
                                              <br>
                                                <div class="col-5 no-padding">
                                                  <button class="btn another-btn prev-btn" (click)="activeModal.close('Close click')">Select another device</button>
                                                </div>
                                                <div class="col-6 no-padding">
                                                  <button class="btn new-confirm-btn confirm-btn signifyBoldlg" (click)="callConfigdata()">Confirm device</button>
                                                </div>
                                              </div>
                                            }
                                            @if (!isErrorPopup) {
                                              <div>
                                                <div class="col-12 signifyBoldxl">Non compatible features</div>
                                                <br><br>
                                                <div class="col-12 signifyBookmd">Selected device:</div>
                                                <div class="col-12 signifyBooklg">{{device.deviceName}}</div>
                                                <br><br>
                                                <div class="col-12 signifyBookmd">Original device:</div>
                                                <div class="col-12 signifyBooklg">{{decryptData?.deviceName}}</div>
                                                <div class="row compare-devices column-container">
                                                  <div class="col-5"></div>
                                                  <div class="col-7">
                                                    <button class="btn confirm-btn signifyBoldlg" (click)="activeModal.close('Close click')">Select another
                                                    device</button>
                                                  </div>
                                                </div><br>
                                              </div>
                                            }
                                          </div>
                                        }

                                        <!-- uploading end here-->
